import { createFileRoute, redirect } from "@tanstack/react-router";

import { ProjectVmEnvironmentPage } from "../components/settings/ProjectVmEnvironmentPage";

export const Route = createFileRoute("/projects/$projectKey_/vm")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: () => <ProjectVmEnvironmentPage projectKey={Route.useParams().projectKey} />,
});
